import { useState, useContext } from "react";

import { CartContext } from "../context/CartContext"
import styles from '../styles/layout.module.css'
import { NavLink } from "react-router-dom";

import { GiDeadWood } from "react-icons/gi";
import { MdArrowForward } from "react-icons/md";
import Marquee from "react-fast-marquee";

const Layout = ({ onCartClick, onAccountClick }) => {
    const [location, setLocation] = useState("")
    const { cartItem } = useContext(CartContext);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false); 

    const menuItems = [
        { label: "Products", locationKey: "products", path: "products" },
        { label: "Company", locationKey: "company", path: "company" },
        { label: "Contact", locationKey: "contact", path: "contact" },
    ];

    return (
        <div className={styles.header}>
            <div className={styles.mainbar}>
                <div className={styles.logocontainer}>
                    <NavLink className={styles.logo} onClick={() => setLocation("")} to='/'><GiDeadWood className={styles.logoicon}/></NavLink>
                </div>
                <div className={styles.companyname}>
                    <p>The Wetland Shop<br/>East 2025</p>
                </div>
                
                <div className={location === "products" ? styles.alertmessage : styles.hidden}>
                    <Marquee speed={75}><p>Free delivery on orders over $300</p></Marquee>
                </div>
                <div className={styles.menucontainer}>
                    <div className={styles.menu}>
                        <ul>
                            <li>
                                <div className={styles.selectionitem}>
                                    <p className={styles.description}>Our store</p>
                                    <div className={styles.menuitem}>
                                        <div className={styles.navitem}>
                                            <div className={styles.item}>
                                                <p className={location === "products" ? styles.activated : ""}>Products</p>
                                            </div>
                                            <div className={styles.item2}>
                                               <NavLink className={styles.navlink} onClick={() => setLocation("products")} to="products"><p>Products</p></NavLink>
                                            </div>
                                        </div>
                                        <MdArrowForward className={styles.arrowicon}/>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className={styles.selectionitem}>
                                    <p className={styles.description}>Who we are</p>
                                    <div className={styles.menuitem}>
                                        <div className={styles.navitem}>
                                            <div className={styles.item}>
                                                <p className={location === "company" ? styles.activated : ""}>Company</p>
                                            </div>
                                            <div className={styles.item2}>
                                               <NavLink className={styles.navlink} onClick={() => setLocation("company")} to="company"><p>Company</p></NavLink>
                                            </div>
                                        </div>
                                        <MdArrowForward className={styles.arrowicon}/>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className={styles.selectionitem}>
                                    <p className={styles.description}>Get in touch</p>
                                    <div className={styles.menuitem}>
                                        <div className={styles.navitem}>
                                            <div className={styles.item}>
                                                <p className={location === "contact" ? styles.activated : ""}>Contact</p>
                                            </div>
                                            <div className={styles.item2}>
                                               <NavLink className={styles.navlink} onClick={() => setLocation("contact")} to="contact"><p>Contact</p></NavLink>
                                            </div>
                                        </div>
                                        <MdArrowForward className={styles.arrowicon}/>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <div className={styles.selectionitem}>
                                    <p className={styles.descriptionHover} onClick={onAccountClick}>Account</p>
                                    <div className={styles.menuitem}>
                                        <div className={styles.navitem}>
                                            <div className={styles.item}>
                                                <p >Cart : {cartItem.length}</p>
                                            </div>
                                            <div className={styles.item2}>
                                                <p className={styles.navlink} onClick={onCartClick}>Cart : {cartItem.length}</p>
                                            </div>
                                        </div>
                                        <MdArrowForward className={styles.arrowicon}/>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className={styles.mobileMenuIcon} onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
                    <p>MENU</p>
                </div>
                <div className={`${styles.menucontainerMobile} ${mobileMenuOpen ? styles.menucontainerMobileActive : ""}`}>
                    <div className={`${styles.menu} ${styles.mobile}`}>
                        <ul>
                            {menuItems.map((item) => (
                                <li key={item.label}>
                                    <NavLink
                                        className={styles.navlink}
                                        to={item.path}
                                        onClick={() => { setLocation(item.locationKey); setMobileMenuOpen(false); }}
                                    >
                                        {item.label}
                                    </NavLink>
                                </li>
                            ))}
                            <li>
                                <p onClick={() => { onAccountClick(); setMobileMenuOpen(false); }}>Account</p>
                                <p onClick={() => { onCartClick(); setMobileMenuOpen(false); }}>Cart: {cartItem.length}</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Layout